// extracted by mini-css-extract-plugin
export default {"container":"Bars_container__ooGaf"};